import React from 'react';
// import './AccountDeletionPolicy.css'; // Optional: if you move styles to a CSS file
import Logo from 'components/common/Logo';

const AccountDeletionPolicy = () => {
  return (
    <div>
      <header style={headerStyle}>
         <Logo width={250} />
      </header>

      <div style={containerStyle}>
        <h2 style={headingStyle}>Account Deletion Policy</h2>

        <h3 style={subheadingStyle}>Request to Delete Your Account</h3>
        <p>
          We respect your right to manage your personal data. If you wish to delete your account,
          please submit a request using the form below.
        </p>

        <h3 style={subheadingStyle}>What Happens Next:</h3>
        <ul>
          <li>Your user profile and login data will be deleted from our system.</li>
          <li>All non-mandatory data will be permanently removed.</li>
          <li>
            Any regulatory medical logs may be retained to comply with HIPAA and pharmacy law.
          </li>
        </ul>

        <h3 style={subheadingStyle}>Required Information:</h3>
        <ul>
          <li>Full Name</li>
          <li>Registered Email Address</li>
          <li>Contact Number</li>
          <li>Reason for Deletion (optional)</li>
        </ul>

        <p>Once verified, your request will be processed within 5 business days.</p>
        <p>
          <strong>To Request Deletion, Email Us At:</strong> support@mapyourmeds.com
        </p>
      </div>
    </div>
  );
};

// Styles
const headerStyle = {
  backgroundColor: '#ADD8E6',
  display: 'flex',
  alignItems: 'center',
  padding: '16px 24px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
};

const logoStyle = {
  height: '48px',
  marginRight: '12px',
};

const containerStyle = {
  maxWidth: '800px',
  margin: '40px auto',
  padding: '30px',
  backgroundColor: 'white',
  borderRadius: '12px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
  color: '#555',
  fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
  lineHeight: 1.6,
};

const headingStyle = {
  fontSize: '24px',
  color: '#0056b3',
  borderBottom: '2px solid #ADD8E6',
  paddingBottom: '6px',
  marginBottom: '24px',
};

const subheadingStyle = {
  fontSize: '18px',
  color: '#333',
  marginTop: '24px',
  marginBottom: '10px',
};

export default AccountDeletionPolicy;
